import { createSelector } from 'reselect';
import { DamzState } from '../../types';
import { getState } from './state';

export type SearchState = DamzState['search'];
export type MessageSearchOrderType = SearchState['order'];

export const getSearchSlice = createSelector([getState], slice => {
  return slice.search;
});

export const getSearchQuery = createSelector(getSearchSlice, state => {
  return state?.q ?? '';
});

export const getMessageSearchOrder = createSelector(getSearchSlice, state => {
  return state?.order ?? 'default';
});

export const getIsSearchingMessages = createSelector(getSearchSlice, state => {
  return !!state?.isSearchingMessages;
});

export const getSearchResults = createSelector(getSearchSlice, state => {
  return state?.results ?? [];
});
